import gql from 'graphql-tag';

/**
 * Fields of the project's power company that the project page reads (documents, registration,
 * print). Shared by the page query and the save of the block project-power-company, so a block
 * save replaces every key of the stored power company and no values of the previous one remain.
 */
export const POWER_COMPANY_OF_PROJECT_FIELDS = gql`
  fragment powerCompanyOfProjectFields on PowerCompany {
    company
    _id
    number
    cosinusPhi
    street
    zip
    city
    registrationEmail
    registrationUrl
    description
    website
    operatorOnSiteElectricMeterChange
    powgridRegistrationPerMailState
    powgridRegistrationOnlineState
    netRegistrationDocumentsApprovedState
    operationRegistrationDocumentsApprovedState
    documentAttachments {
      id
      path
      thumbnail
      filename
      displayFilename
      size
      mimetype
    }
    netRegistrationLinkedDocuments {
      id
      name
    }
    operationRegistrationLinkedDocuments {
      id
      name
    }
  }
`;
